export enum ButtonSize {
  MINI = 'mini',
  SMALL = 'small',
  LARGE = 'large',
  XLARGE = 'xlarge',
  XXLARGE = 'xxlarge',
}
